/****************************************************************************************************************
 *  ©2018 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
 *
 * The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
 * other pending or existing intellectual property rights in India, the United States and other countries. The Program
 * may contain / reference third party or open source components, the rights to which continue to remain with the
 * applicable third party licensors or the open source community as the case may be and nothing here transfers the
 * rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
 * storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
 * photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
 * severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
 *****************************************************************************************************************/

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfileService } from '../../core/services/profile.service';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../ba-supplier-ui.constants';
import { SuppUserService } from './supp-user.service';

@Injectable()
export class SupplierACLService {

    public storage: any;
    constructor(private profileService: ProfileService, private http: HttpClient, private _userService: SuppUserService) { }

    isRouteAccessible(routeName: string): Observable<boolean> {
        return new Observable(observer => {
            let profileObj = this.profileService.fetchProfile();
            if (!profileObj) {
                this.profileService.getProfileFromSSO().subscribe((result) => {
                    sessionStorage.setItem('profile', result);
                    let acessible = this.checkIfRouteIsAccessible(result, routeName);
                    observer.next(acessible);
                    observer.complete();
                });
            } else {
                let acessible = this.checkIfRouteIsAccessible(profileObj, routeName);
                observer.next(acessible);
                observer.complete();

            }
        });

        // return new Observable(observer => {
        //     this._userService.getUserProfile().toPromise()
        //         .then(response => {
        //             if (response.profileCompleted || routeName === 'user-profile') {
        //                 let profileObj = this.profileService.fetchProfile();
        //                 if (!profileObj) {
        //                     this.profileService.getProfileFromSSO().subscribe((result) => {
        //                         sessionStorage.setItem('profile', JSON.stringify(result));
        //                         let acessible = this.checkIfRouteIsAccessible(result, routeName);
        //                         observer.next(acessible);
        //                         observer.complete();
        //                     });
        //                 } else {
        //                     let acessible = this.checkIfRouteIsAccessible(JSON.parse(profileObj), routeName);
        //                     observer.next(acessible);
        //                     observer.complete();
        //                 }
        //             } else {
        //                 observer.next(false); // Need to complete profile first
        //                 observer.complete();
        //             }
        //         })
        //         .catch(error => {
        //             console.log('Error fetching profile');
        //         });
        // });
    }
    checkIfRouteIsAccessible(profile: any, routeName: string): boolean {
        // let isAccessible = false;
        // for (let i = 0; i < profile.permissions.length; i++) {
        //     for (let j = 0; j < profile.permissions[i].apps.length; j++) {
        //         if (profile.permissions[i].apps[j].name === 'SUP') {
        //             for (let k = 0; k < profile.permissions[i].apps[j].resources.length; k++) {
        //                 if (profile.permissions[i].apps[j].resources[k].name === routeName) {
        //                     isAccessible = true;
        //                     break;
        //                 }
        //             }
        //         }
        //     }
        // }

        // return isAccessible;
        return true;
    }
    // getRerouteUrl(url: string) {
    //     let profileObj = this.profileService.fetchProfile();
    //     let reRouteUrl = ['/'];
    //     if (profileObj) {
    //         profileObj = JSON.parse(profileObj);
    //         if (profileObj['roles']) {
    //             for (let i = 0; i < profileObj['roles'].length; i++) {
    //                 if (url === 'price-request' && profileObj['roles'][i] === 'Sourcing_Manager') {
    //                     console.log('Since he is sourcing manager, rerouting him to price request')
    //                     reRouteUrl = ['/tsm/price-requests'];
    //                     break;
    //                 } else if (url === 'inbox' && profileObj['roles'][i] === 'Sourcing_Specialist') {
    //                     console.log('Since he is sourcing specialist, rerouting him to request inbox')
    //                     reRouteUrl = ['/tsm/'];
    //                     break;
    //                 }
    //             }
    //         }
    //     }
    //     return reRouteUrl;
    // }
    getSideBarMenus() {
        console.log('get side bars supplier');
        return new Observable(observer => {
            let profileObj = this.profileService.fetchProfile();
            if (profileObj) {
                let menus = [];
                profileObj = JSON.parse(profileObj);
                for (let i = 0; i < profileObj['roles'].length; i++) {
                    if (profileObj['roles'][i] === 'Supplier') {
                        const menusSA = [
                            {
                                name: 'Inbox',
                                iconName: 'subdirectory_arrow_right',
                                path: 'sup/inbox'
                            }
                        ];
                        menus = menus.concat(menusSA);
                    } else if (profileObj['roles'][i] === 'Supplier_Admin') {
                        const menusS = [
                            {
                                name: 'Users',
                                iconName: 'subdirectory_arrow_right',
                                path: 'sup/users'
                            }
                        ];
                        menus = menus.concat(menusS);
                    }
                }
                const menusS = [
                    {
                        name: 'Survey',
                        iconName: 'subdirectory_arrow_right',
                        path: 'sup/survey-list'
                    }
                ];
                menus = menus.concat(menusS);
                observer.next(menus);
                observer.complete();
            } else {
                this.profileService.getProfileFromSSO().subscribe((result) => {
                    let menus = [];
                    for (let i = 0; i < result['roles'].length; i++) {
                        if (result['roles'][i] === 'Supplier') {
                            const menusSA = [
                                {
                                    name: 'Inbox',
                                    iconName: 'subdirectory_arrow_right',
                                    path: 'sup/inbox'
                                }
                            ];
                            menus = menus.concat(menusSA);
                        } else if (result['roles'][i] === 'Supplier_Admin') {
                            const menusS = [
                                {
                                    name: 'Users',
                                    iconName: 'subdirectory_arrow_right',
                                    path: 'sup/users'
                                }
                            ];
                            menus = menus.concat(menusS);
                        }
                    }
                    observer.next(menus);
                    observer.complete();
                });
            }

        });
    }
}


